<div class="snackbar-content">
  <mat-icon class="snackbar-icon">{{ getIcon(data.type) }}</mat-icon>
  <div class="snackbar-text">
    <strong>{{ data.title }}</strong>
    <div>{{ data.message }}</div>
  </div>
</div>
